export default __webpack_public_path__ + "static/90-fee558c26d7aa85aed7e361b7d74f46e.png";